import React from "react";
import {
  Box,
  Grid,
  Typography,
  Card,
  CardContent,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
  Divider,
  useTheme,
} from "@mui/material";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Footer from "examples/Footer";
import { BlueButton } from "styles";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
import CookieIcon from "@mui/icons-material/Cookie";
import IntegrationInstructionsIcon from "@mui/icons-material/IntegrationInstructions";
import SettingsSuggestIcon from "@mui/icons-material/SettingsSuggest";
import BarChartIcon from "@mui/icons-material/BarChart";
import DomainIcon from "@mui/icons-material/Domain";
import { useNavigate } from "react-router-dom";

function Dashboard() {
  const theme = useTheme();
  const navigate = useNavigate();

  const featureCards = [
    {
      icon: <DomainIcon fontSize="large" />,
      title: "Domainler & Web Siteleri",
      description: "Tüm domainlerinizi ve web sitelerinizi merkezi olarak yönetin",
      route: "/domains",
      color: "primary",
    },
    {
      icon: <CookieIcon fontSize="large" />,
      title: "Çerez Yönetimi",
      description: "Çerez kategorilerini ve tarama geçmişini yönetin",
      route: "/cookies/categories",
      color: "success",
    },
    {
      icon: <IntegrationInstructionsIcon fontSize="large" />,
      title: "Entegrasyonlar",
      description: "Çerez onay bildirimi ve Google Consent entegrasyonları",
      route: "/entegrations/cmp-banner",
      color: "info",
    },
    {
      icon: <SettingsSuggestIcon fontSize="large" />,
      title: "Özelleştirme",
      description: "Banner düzeni, tasarım ve dil ayarlarını özelleştirin",
      route: "/configuration/layout",
      color: "warning",
    },
    {
      icon: <BarChartIcon fontSize="large" />,
      title: "Raporlar",
      description: "Çerez onay ve red oranlarını görün karşılaştırın",
      route: "/consent-logs",
      color: "error",
    },
  ];

  const cookieFaqs = [
    {
      question: "Çerez Onay Bildirimi Nedir?",
      answer: "Çerez onay bildirimi, ziyaretçilerinizin hangi çerez türlerine izin vereceğini seçebileceği bir mekanizmadır. GDPR ve diğer veri koruma yasalarına uyum sağlamak için gereklidir."
    },
    {
      question: "Google Consent Mode Nasıl Çalışır?",
      answer: "Google Consent Mode, Google etiketlerinin davranışını kullanıcının analitik ve reklam tercihleriyle eşleştirir. Gelişmiş modda izin reddedildiğinde ilgili Google ölçüm çerezleri yazılmaz; Google etiketleri çerezsiz ölçüm sinyalleri gönderebilir."
    },
    {
      question: "Çerez Kategorileri Nasıl Belirlenir?",
      answer: "Çerezler işlevlerine göre kategorilere ayrılır: Gerekli, Performans, Fonksiyonel, Hedefleme. Her kategori için ayrı onay alınmalıdır."
    },
    {
      question: "Otomatik Çerez Taraması Ne Sıklıkla Yapılır?",
      answer: "Sistem uygun siteleri aylık olarak yeniden tarar. Manuel taramalarda kötüye kullanımı ve gereksiz yükü önleyen bekleme süresi uygulanabilir."
    }
  ];

  return (
    <DashboardLayout>

      <MDBox mt={2} mb={4}>
        <Grid container spacing={3}>
          {/* Hoş Geldiniz Kartı */}
          <Grid item xs={12}>
  <Card sx={{ 
    boxShadow: 3,
    minHeight: 300,
    position: 'relative',
    overflow: 'hidden'
  }}>
    <Grid container alignItems="center" sx={{ height: '100%' }}>
      {/* Sol Tarafta Yazı ve Buton (%70) */}
      <Grid item xs={12} md={7} sx={{ p: 4, zIndex: 2 }}>
        <Typography variant="h3" gutterBottom sx={{ fontWeight: 'bold', mb: 3 }}>
          Logicookie Kontrol Paneline Hoş Geldiniz
        </Typography>
        <Typography variant="h6" color="text.secondary" paragraph sx={{ mb: 4 }}>
          Çerez yönetimi ve GDPR uyumluluk araçlarınızı tek bir merkezden yönetin.
          Sisteminizdeki tüm web sitelerinizin çerez politikalarını kolayca yönetebilir,
          entegrasyonları yapılandırabilir ve raporları görüntüleyebilirsiniz.
        </Typography>
        <BlueButton
          
          size="large"
          startIcon={<RocketLaunchIcon />}
          onClick={() => navigate("/entegrations/cmp-banner")}
          sx={{
            px: 4,
            py: 1.5,
            fontSize: '1.1rem',
            boxShadow: 3,
            '&:hover': {
              transform: 'translateY(-2px)',
              boxShadow: 6
            },
            transition: 'all 0.3s ease'
          }}
        >
          Hızlı Başlangıç Rehberi
        </BlueButton>
      </Grid>
      
      {/* Sağ Tarafta Görsel (%30) */}
      <Grid item xs={12} md={5} sx={{ 
        height: '100%',
        position: 'relative',
        display: { xs: 'none', md: 'block',lineHeight:0 } // Mobilde gizle, masaüstünde göster
      }}>
        <Box
          component="img"
          src="https://images.unsplash.com/photo-1551836022-d5d88e9218df?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80"
          alt="Cookie Management"
          sx={{
            
            height: '100%',
            width: '100%',
            objectFit: 'cover',
            clipPath: 'polygon(20% 0%, 100% 0%, 100% 100%, 0% 100%)'
          }}
        />
        
      </Grid>
    </Grid>
  
  </Card>
</Grid>

          {/* Özellik Kartları */}
          {featureCards.map((card, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card sx={{ height: "100%", boxShadow: 2 }}>
                <CardContent sx={{ p: 3, height: "100%", display: "flex", flexDirection: "column" }}>
                  <Box sx={{ color: theme.palette[card.color].main, mb: 2 }}>
                    {card.icon}
                  </Box>
                  <Typography variant="h6" gutterBottom>
                    {card.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary" paragraph sx={{ flexGrow: 1 }}>
                    {card.description}
                  </Typography>
                  <BlueButton
                    variant="outlined"
                    onClick={() => navigate(card.route)}
                    sx={{ alignSelf: "flex-start" }}
                  >
                    Sayfaya Git
                  </BlueButton>
                </CardContent>
              </Card>
            </Grid>
          ))}

          {/* Çerez Yönetimi SSS */}
          <Grid item xs={12}>
  <Card sx={{ 
    boxShadow: '0px 10px 30px rgba(0, 0, 0, 0.08)',
    borderRadius: '16px',
    overflow: 'hidden',
    border: 'none'
  }}>
    <CardContent sx={{ p: 0 }}>
      {/* Başlık Bölümü */}
      <Box sx={{
        background: 'white',
        p: 4,
        color: 'white'
      }}>
        <Typography variant="h4" sx={{ 
          fontWeight: 700,
          mb: 1,
          fontFamily: "'Inter', sans-serif"
        }}>
          Çözüm Merkezi
        </Typography>
        <Typography variant="body1" sx={{ 
          opacity: 0.9,
          fontFamily: "'Inter', sans-serif"
        }}>
          Çerez yönetimi ve GDPR uyumluluğu hakkında sık sorulan sorular
        </Typography>
      </Box>

      {/* SSS Bölümü */}
      <Box sx={{ p: 3 }}>
        {cookieFaqs.map((faq, index) => (
          <Accordion 
            key={index}
            sx={{
              mb: 2,
              borderRadius: '12px !important',
              boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
              overflow: 'hidden',
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
              '&:before': { display: 'none' },
              '&.Mui-expanded': {
                margin: '16px 0',
                boxShadow: '0 8px 24px rgba(0,0,0,0.1)'
              },
              border: '1px solid rgba(0, 0, 0, 0.05)'
            }}
            disableGutters
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon sx={{ 
                color: '#1976d2',
                fontSize: '1.8rem'
              }} />}
              sx={{
                backgroundColor: '#F9FAFF',
                py: 2.5,
                px: 3,
                minHeight: 'auto',
                '&.Mui-expanded': {
                  backgroundColor: '#F0F4FF',
                  borderBottom: '1px solid rgba(0, 0, 0, 0.05)'
                },
                '& .MuiAccordionSummary-content': {
                  alignItems: 'center',
                  gap: 2
                }
              }}
            >
              <Box sx={{
                width: 36,
                height: 36,
                borderRadius: '10px',
                background: '#1976d2',
                color: 'white',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0
              }}>
                <Typography variant="h6" sx={{ 
                  color: "aliceblue",
                  fontWeight: 700
                }}>
                  {index + 1}
                </Typography>
              </Box>
              <Typography variant="h6" sx={{ 
                fontWeight: 600,
                fontFamily: "'Inter', sans-serif",
                color: 'white'
              }}>
                {faq.question}
              </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ 
              backgroundColor: '#FFFFFF',
              py: 3,
              px: 4,
              borderTop: '1px solid rgba(0, 0, 0, 0.05)'
            }}>
              <Box sx={{ 
                display: 'flex', 
                gap: 2,
                alignItems: 'flex-start'
              }}>
                <Box sx={{ 
                  color: '#1976d2',
                  fontSize: '1.5rem',
                  lineHeight: 1,
                  mt: 0.5
                }}>
                  •
                </Box>
                <Typography variant="body1" sx={{
                  color: 'text.secondary',
                  fontFamily: "'Inter', sans-serif",
                  lineHeight: 1.7
                }}>
                  {faq.answer}
                </Typography>
              </Box>
            </AccordionDetails>
          </Accordion>
        ))}
      </Box>

      {/* Destek Bölümü */}
      <Box sx={{ 
        p: 3, 
        textAlign: 'center',
        borderTop: '1px solid rgba(0, 0, 0, 0.05)',
        backgroundColor: '#F9FAFF'
      }}>
        <Typography variant="body1" sx={{ 
          mb: 2,
          color: 'text.secondary',
          fontFamily: "'Inter', sans-serif"
        }}>
          Cevabını bulamadığın bir soru mu var?
        </Typography>
        <BlueButton
         
          onClick={() => navigate("/support")}
          sx={{
            px: 4,
            py: 1.5,
            fontWeight: 600,
            borderRadius: '12px',
            boxShadow: '0 4px 12px rgba(107, 115, 255, 0.3)',
            textTransform: 'none',
            fontSize: '1rem',
            fontFamily: "'Inter', sans-serif"
          }}
        >
          Destek Ekibiyle İletişime Geç
        </BlueButton>
      </Box>
    </CardContent>
  </Card>
</Grid>

        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Dashboard;
